<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Reports" title="Raw Material Report"/>

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">

									<div class="col-md-2">
										<label class="control-label">From Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="start_date" :min="min" :max="max" value-as-string @change="fetchReport()">
									</div>
									<div class="col-md-2">
										<label class="control-label">To Date:<span class="text-danger">*</span></label>
										<input class="form-control" type="date" v-model="end_date" :min="min" :max="max" value-as-string @change="fetchReport()">
									</div>

									<div class="col-md-2">
										<label class="control-label">Material</label>
										<select class="form-select" v-model="material_id" @change="fetchReport()">
											<option value="">All Materials</option>
											<option :value="material.id" v-for="material in rawMaterails" :key="material.id">
                                                {{material.raw_material_name}}
                                            </option>
										</select>
									</div>

									<div class="col-md-2" style="margin-top: 33px;">
										<!-- <div class="btn btn-info" v-if="Boolean(materials.length)" @click="generatePDF()">Pdf</div> -->
										<div  class="btn btn-info"  @click="generatePDF()">Download</div>
									</div>
									<div class="col-md-4">

									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-body">

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
											<th>Material</th>
											<th>Current Stock</th>
											<th>Updated On</th>
											<th>Action</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(materials.length)">
                                        <tr align="center" v-for="(material,index) in materials" :key="material.id">
                                            <td>{{index + 1}}</td>
											<td>{{material.raw_material_name}}</td>
											<td>{{material.current_stock}}</td>
											<td>{{$filters.formatDate(material.updated_at)}}</td>
											<td>
												<button class="btn btn-primary btn-sm me-2 mb-2"  @click="generateExcel(material.id)">Log Report</button>
											</td>
                                        </tr>
                                       

                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="8" class="text-center">No data</td>
										</tr>
									</tbody> 
								</table>
							</div>

							<!----pagination starts --->
							<caption v-if="Boolean(materials.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchReport(page.url + '&start_date=' + start_date + '&end_date=' + end_date +  '&limit=' + listing_length)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav> 
							<!----pagination ends --->

						</div>
					</div>
				</div>
			</div>
		</div>

   	</div>
</template>


<script>

	export default {
		name: "Product Stock Report",
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2021-01-01') 
	      
			return {
				rawMaterails: {},
				materials:[],
				pagination: {},
				start_date: '2021-01-01',
				end_date: today_str,
				
				min: minDate,
				max: today,
				material_id:"",
				keyword: "",
				listing_length: 10,
				token: "",
				i: 1,				
			};
		},
		mounted() {},

		created() {
			this.fetchMaterials();
			this.fetchReport();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchMaterials(page_url = null) {
                let url = "/staffs/getRawMaterials"; 
                page_url = page_url || url;

                this.getToken();
                this.$axios
                .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.rawMaterails = responseData;
                                                    
                })
                .catch((err) => console.log(err));
            },
			

			fetchReport(page_url = null) {
				this.getToken();
				let url = "/staffs/rawMaterialsReport?limit=" + this.listing_length + "&from_date=" + this.start_date + "&to_date=" + this.end_date + "&material_id=" + this.material_id;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.materials = responseData.materials.data;
						this.pagination = responseData.materials.links;
						this.from = responseData.materials.from;
						this.to = responseData.materials.to;
						this.total = responseData.materials.total;
					})
					.catch((err) => console.log(err));
			},

			generatePDF() 
			{
				this.getToken();
				let page_url = "/staffs/rawMaterialsReportDownload?material_id=" + this.material_id  + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Raw_material_report" + this.start_date + "_" + this.end_date + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();
					this.pdf.loading = false;
						
				})
				.catch((err) => console.log(err));
			},

			generateExcel(material_id) {
				this.getToken();

				let page_url = `/staffs/rawMaterialLogReport?material_id=${material_id}`;
				this.$axios
					.get(page_url, {
						headers: { Authorization: "Bearer " + this.token },
						responseType: "blob", // Important: expect binary data
					})
					.then((response) => {
						const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = `raw_material_log_report.xlsx`;
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					})
					.catch((err) => {
						console.error(err);
						this.$swal("Failed to download report", "", "error");
					});
			}


		},
	};
</script>
